<template>
  <question-wrapper :questionId="questionId">
    <question-header :title="title"/>
    <question-text
      :explainer="explainer"
      :pass="pass"
      :fail="fail"
      :skip="skip"
      :callToAction="callToAction"
      v-on:doTest="startPreviewTest"/>

      <div class="col-md-12 video-test media-test twilio-test" v-if="videoProvider==='twilio'" v-show="testRunning">
        <div class="col-md-6">
          <media-selector
            :ref="'selectVideoInput'"
            :device="'camera'"
            :inputType="'video'"
            :inputId="videoInput"
            :allowDisable="true"
            v-on:changeDevice="deviceChanged"
            v-on:noDevicesFound="noDevicesFound">
          </media-selector>

          <twilio-video-preview
            :ref="'twilio-video-comp'"
            v-if="videoProvider==='twilio'"
            v-on:audioTrackUpdated="setAudioStream"
            v-on:twilioFail="failTwilioTest"
            v-on:statsReport="analyseStats"
            :mediaOpts="mediaOpts"
            :micDisabled="micDisabled"
            :camDisabled="camDisabled"
            :progress="progress"
            :roomName="twilioRoomName"
            roomType="group"
          />

          <!--<opentok-video-preview-->
            <!--:ref="'opentok-video-comp'"-->
            <!--v-if="videoProvider==='opentok'"-->
            <!--v-on:previewDeviceChanged="deviceChanged"-->
            <!--v-on:passTest="passTest"-->
            <!--v-on:failOTTest="failOTTest"-->
            <!--:micDisabled="micDisabled"-->
            <!--:camDisabled="camDisabled">-->
           <!--</opentok-video-preview>-->
        </div>

         <div class="col-md-6 video-test-explainer" v-if="videoInput === 'disabled'">
          <h4 v-translate>Video Disabled</h4>
          <p v-translate>You will be joining the class in audio only mode.</p>
          <p v-translate>This means that your teacher and classmates will not be able to see you.</p>
          <p v-translate>However, you will still be able to hear and see them inside the classroom.</p>
        </div>

        <div class="col-md-6 video-test-explainer" v-else>
          <h4 v-translate>Video Preview</h4>
          <p v-translate>If you have selected the correct webcam, you should see your smiling face.</p>
          <p v-translate>You can change the webcam input from the dropdown menu above the preview.</p>

          <div class="video-call-quality">
            <h4 v-translate v-if="status !== 'complete'">Video Test in Progress</h4>
            <h4 v-translate v-else>Video Quality</h4>
            <quality-report
              v-if="videoProvider === 'twilio'"
              v-on:qualityReport="qualityReport"
              :reports="videoCallStats"
              :reportType="'video'"
              :progress="progress">
            </quality-report>
          </div>
        </div>

        <div class="col-md-12 pad-top video-test-progress" v-if="!(videoInput === 'disabled')">
          <progress-bar :progress="progress"></progress-bar>
        </div>

      </div>
      <div class="col-md-12 audio-test media-test twilio-test" v-if="videoProvider==='twilio'" v-show="testRunning">
      <div class="col-md-6">
        <media-selector
          :ref="'selectAudioInput'"
          :device="'microphone'"
          :inputType="'audio'"
          :inputId="audioInput"
          :allowDisable="false"
          v-on:changeDevice="deviceChanged"
          v-on:noDevicesFound="noDevicesFound">
        </media-selector>

        <canvas-audio-preview
          v-if="audioMediaStream"
          :audioMediaStream="audioMediaStream"
          @maxAudioLevel="testMaxAudioLevel"
        />

        <div class="audio-call-quality">
            <h4 v-translate v-if="status !== 'complete'">Audio Test in Progress</h4>
            <h4 v-translate v-else>Audio Quality</h4>
          <quality-report
            v-if="videoProvider==='twilio'"
            v-on:qualityReport="qualityReport"
            :reports="audioCallStats"
            :reportType="'audio'"
            :progress="progress"
            :audioLevelFallback="maxAudioLevel"
            :usersBrowserName="usersBrowserName">
          </quality-report>
        </div>

      </div>
      <div class="col-md-6 audio-test-explainer" >
        <h4 v-translate>Audio Preview</h4>
        <p v-translate>Please say something to confirm that sound indicator is picking up your microphone.</p>
        <p v-translate>If you notice a problem, please change the audio input from the dropdown menu above it.</p>

      </div>

      <div class="col-md-12 pad-top audio-test-progress">
        <progress-bar :progress="progress"></progress-bar>
      </div>

    </div>

        <div class="result col-md-12">
        	<pass-message :pass="pass" :nextPage="homeUrl" :previousPage="previousPage" :finalTest="true">
            <div slot="message">
              <div class="supported-browsers">
                <h2><translate>Congratulations!</translate></h2>
                <p><translate>All tests passed.</translate></p>
                <p><translate>Happy Learning</translate></p>
              </div>
            </div>
			    </pass-message>

			<!-- Fail -->
      		<div class="fail" v-if="fail">
            <h2><translate>Test Failed</translate></h2>
            <div id="no-mic" v-if="deviceFail.length">
              <p>
                <translate>We can't access your</translate>&nbsp;
                <b v-translate v-for="device in deviceFail" :key="device" data-po-exclude="true">{{ device }}</b>&nbsp;
                <translate>input</translate>.
              </p>
              <p>
                <translate>You may need to restart your device or re-install your</translate>&nbsp;
                <b v-translate v-for="device in deviceFail" :key="device" data-po-exclude="true">{{ deviceKeys[device] }}</b>.
              </p>
            </div>

            <p v-if="twilioFail">
              <translate>Sorry. There was a problem accessing your webcam or connecting to our media server.</translate>&nbsp;
              <translate>Please contact support and we'll try to solve this as soon as possible.</translate>
            </p>

            <!--<div id="access-denied">-->
              <!--<p>-->
                <!--<translate>We can't access your device</translate>-->
              <!--</p>-->
            <!--</div>-->
            <div class="quality-fail" v-if="qualityReports.length">
              <p v-if="networkFail">
                <translate>We have detected a significant delay or loss of information in your audio / video stream.</translate>&nbsp;
                <translate>This may be caused by a poor internet connection.</translate>&nbsp;
                <translate>Unfortunately, these issues prevent you from participating fully in the online class.</translate>
              </p>

              <p v-if="audioLevelFail">
                <translate>We could not detect any volume in your audio stream.</translate>
              </p>

              <p v-if="frameRateFail">
                <translate>There is a problem with your video feed.</translate>
              </p>

              <div class="supported-browsers">
                <h3 class="text-center"><translate>Fix This</translate></h3>
                <div v-if="networkFail">

                  <p v-translate>Check your router and close any other apps that may be using bandwidth like Netflix, Spotify or Skype.</p>
                  <p>
                    <translate>If you still have an issue you can join the class in audio only mode.</translate>&nbsp;
                    <translate>Select the "disable" option in the video dropdown and re-run this test.</translate>
                  </p>
                </div>

                <div v-if="audioLevelFail">
                  <p v-translate>You can change the audio input using the drop down menu above the audio indicator.</p>
                  <p v-translate>If this doesn't work, please restart your device or re-install your audio drivers.</p>
                </div>

                <div v-if="frameRateFail">
                  <p v-translate>You can change the video input using the drop down selector above the video preview.</p>
                  <p v-translate>If this doesn't work, please restart your device or re-install the drivers.</p>
                  <p>
                    <translate>If you still have an issue you can join the class in audio only mode.</translate>&nbsp;
                    <translate>Select the "disable" option in the video dropdown and re-run this test.</translate>
                  </p>
                </div>

              </div>
            </div>

          </div>
     </div>
    <div id="bottom-anchor"></div>
  	</question-wrapper>
</template>

<script>
  import { v1 as uuidv1 } from 'uuid'
	import BasePage from './common/BasePage.vue'
  import TwilioVideoPreview from './common/TwilioVideoPreview.vue'
  import CanvasAudioPreview from './common/CanvasAudioPreview.vue'
  import QualityReport from './qualityTest/QualityReport.vue'
  import ProgressBar from './common/ProgressBar.vue'
  import { markForTranslation as _ } from '@/../../i18n/scripts/utils'
	import {mapState, mapActions, mapGetters} from 'vuex'
  import MediaSelector from './common/MediaSelector.vue'

  /**
   * This is the _*Page*_ component that holds all the components and data necessary for a full _*Preview*_ test.
   * Like all pages it has a header, an explanation of the test, a button to execute the test
   * If the test is passed the user should see the video feed their own webcam and a audio analyzer graphic, indicating that their microphone is working properly
   */
	export default {

		name: 'Preview',
    mixins: [BasePage],
		data () {
			return {
			  vuexModule: 'preview',
        testRunning: false,
			  audioMediaStream: null,
        deviceFail: [],
        deviceKeys: {
			    'video': _('camera'),
          'audio': _('microphone')
        },
        accessDeniedError: false,
        videoCallStats: [],
        audioCallStats: [],
        progress: 0,
        qualityReports: [],
        allTestsComplete: null,
        twilioFail: false,
        maxAudioLevel: 0
      }
		},

		components: {
      'twilio-video-preview': TwilioVideoPreview,
      'canvas-audio-preview': CanvasAudioPreview,
      'quality-report': QualityReport,
      'progress-bar': ProgressBar,
      'media-selector': MediaSelector
		},

		computed: {

			...mapState('preview', [
				'videoProvider', 'twilioMediaOpts', 'pass', 'fail'
			]),

      ...mapState('camera', {
        'camDisabled': 'disabled'
      }),

      ...mapGetters('preview', [
        'audioInput', 'videoInput'
      ]),

      status () {
			  if (this.progress === 0) {
          return 'not-started'
        }
        if (this.progress === 100) {
          return 'complete'
        }
        return 'in-progress'
      },

      homeUrl () {
			  return this.config.troubleshooter ? this.config.troubleshooter.return_url : this.nextPage
      },

      networkFail () {
			  return (this.qualityReports.filter(rep => ['latency', 'packets', 'packetLoss'].includes(rep.metric))).length
      },

      frameRateFail () {
			  return (this.qualityReports.filter(rep => (rep.metric === 'frameRate'))).length
      },

      audioLevelFail () {
			  return (this.qualityReports.filter(rep => (rep.metric === 'audioLevel'))).length
      },

      twilioRoomName () {
			  return `lc-troubleshooter-${uuidv1()}`
      },

      mediaOpts () {
			  let videoOpts = this.twilioMediaOpts.video
        const audioOpts = this.twilioMediaOpts.audio
        if (this.usersBrowserName === 'safari') {
          videoOpts = {...videoOpts, 'width': null}
        }
        return {'video': videoOpts, 'audio': audioOpts}
      }
		},

		methods: {

      ...mapActions('preview', ['changeMediaDevice']),

      startPreviewTest () {
        this.resetPreviewTest()
        this.testRunning = true
        const videoChild = this.$refs[`${this.videoProvider}-video-comp`]
        return videoChild.startPreviewTest()
      },

      resetPreviewTest () {
        const videoChild = this.$refs[`${this.videoProvider}-video-comp`]
        videoChild.resetPreviewTest()
        this.testRunning = false
        this.audioMediaStream = null
        this.maxAudioLevel = 0
        this.videoCallStats = []
        this.audioCallStats = []
        this.qualityReports = []
        this.progress = 0
        this.resetTest()
      },

      deviceChanged (payload) {
        this.changeMediaDevice(payload)
        this.resetPreviewTest()
      },

      noDevicesFound (inputType) {
        if (this.deviceFail.indexOf(inputType) < 0) {
          this.deviceFail.push(inputType)
        }
        this.failTest(this.statusMessage({'desc': 'No Devices Found'}))
      },

      setAudioStream (audioMediaStream) {
        this.audioMediaStream = audioMediaStream
      },

      testMaxAudioLevel (lev) {
        this.maxAudioLevel = lev
      },

      failOTTest (error) {
        if (error.name === 'OT_USER_MEDIA_ACCESS_DENIED') {
          this.accessDeniedError = true
          this.failTest()
        }
      },

      failTwilioTest (error) {
        this.twilioFail = true
        this.failTest(this.statusMessage({'desc': 'Error in the twilio workflow'}, error))
        this.progress = 100
        this.scrollToBottom()
      },

      scrollToBottom () {
        return this.$nextTick().then(() => {
          return this.$el.querySelector('#bottom-anchor').scrollIntoView({
            behavior: 'smooth'
          })
        })
      },

      analyseStats (payload) {
        if (payload.video) { this.videoCallStats.push(payload.video) }
        if (payload.audio) { this.audioCallStats.push(payload.audio) }
        this.progress = Math.min(100, Math.round((payload.statsCount / payload.statsCountLimit) * 100))
      },

      qualityReport (report) {
        this.qualityReports = [...this.qualityReports, ...report.failures]

        if (this.allTestsComplete) {
          window.clearTimeout(this.allTestsComplete)
        }

        return new Promise((resolve, reject) => {
          this.allTestsComplete = window.setTimeout(() => {
            if (this.qualityReports.length) {
              const err = {
              'name': 'Call Quality Error',
              'message': this.qualityReports
            }
              this.failTest(this.statusMessage({'desc': 'Failed the preview test on quality'}, err))
            } else {
              this.passTest(this.statusMessage({'desc': 'User has passed the troubleshooter', 'status': 'pass'}))
            }
            // this.logInfo
            this.scrollToBottom()
            return resolve()
          }, 1000)
        })
      }
		},

    created () {
      if (this.camDisabled) {
        this.changeMediaDevice({
          'inputType': 'video',
          'deviceId': 'disabled'
        })
      }
    }
		/**
    * _*Listens*_ to the custom _doTest_ event fired by the Question component and executes the _startPreview()_ method callback
    * @event doTest
    * @type {Event}
    */
		/**
    * _*Listens*_ to the custom _noDevicesFound_ event fired by the Video Preview component and executes the _noDevicesFound()_ method callback
    * @event noDevicesFound
    * @type {Event}
    */
		/**
    * _*Listens*_ to the custom _previewDeviceChanged_ event fired by the Video Preview component and executes the _deviceChanged()_ method callback
    * @event previewDeviceChanged
    * @type {Event}
    */
		/**
    * _*Listens*_ to the custom _audioTrackUpdated_ event fired by the Video Preview component and executes the _setAudioStream()_ method callback
    * @event audioTrackUpdated
    * @type {Event}
    */
	}

</script>

<style scoped>

  .media-test{
    margin-top: 20px;
    border-top: 1px solid #CCCCCC;
    padding-top: 15px
  }

  .media-test p {
    text-align: left;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to{
    opacity: 0;
  }

  #bottom-anchor{
    display:block;
    clear:both;
  }

  /deep/ #preview-video {
    max-height: 256px;
    overflow: hidden;
  }

</style>
